var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"background-color":"ghostwhite","height":"78vh"},attrs:{"justify":"center"}},_vm._l((_vm.products),function(product){return _c('Product',{key:product.name,attrs:{"item":product}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }